export default __webpack_public_path__ + "static/media/file_management.fdb0c8c2.svg";